<mat-dialog-content>
  <div class="flex-1 d-flex jc-center ai-center" *ngIf="!resolvedData?.data">
    <suvo-core-loading-spinner message="Loading Cluster..."></suvo-core-loading-spinner>
  </div>
  <div *ngIf="resolvedData?.data" class="loaded-data-container">
    <div class="title-container d-flex fd-row jc-between ai-center">
      <h4>{{ data.alias.charAt(0).toUpperCase() + data.alias.slice(1) }} in this Cluster</h4>
      <button mat-icon-button (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div>
      <div
        *ngFor="let dataSourceItem of resolvedData.data"
        class="d-flex fd-row"
        class="item-row"
        (click)="itemClicked(dataSourceItem)"
      >
        <p>{{ dataSourceItem.data.index }} - {{ dataSourceItem.data.title }}</p>
      </div>
    </div>
  </div>
</mat-dialog-content>
